import React from 'react';
import { Label } from '../atoms/label';
import { Link } from '../atoms/link';

export const WeeksDateCrawl = (props) => {
    const {
        data,
        data2,
        onClickFacility,
        onClick,
        onClickDetail
    } = props;

    const cols = data.map((value, index) =>
        <th key={'col1' + index} className={value.color == "black" ? "crawlSearch_tdStyleBlack" : (value.color == "red" ? "crawlSearch_tdStyleRed" : "crawlSearch_tdStyleBlue")}>
            <Label label={value.day} className="crawlSearch_calendarDate" />
            <Label label={value.week} className="crawlSearch_calendarDay" />
        </th>
    );
    const cols2 = data2.map(facility =>
        <tr key={facility.facilityId}>
            <td className="crawlSearch_detailBtnCol" >
                <Link linkTitle="詳細" className={facility.kushitsuSuList ? "crawlSearch_detailBtn" : "crawlSearch_disabledDetailBtn"} onClick={facility.kushitsuSuList ? () => { onClickDetail(facility.facilityId, facility.facilityName) } : null} />
            </td>
            <td className="crawlSearch_facilityNameCol" onClick={() => onClickFacility(facility.facilityId, facility.facilityName)}>
                <Label label={facility.facilityName} className="crawlSearch_facilityNameLabel" />
            </td>
            {facility.vacancyDateList?.map((vacancy, vacancyIndex) =>
                <td key={facility.facilityId + "_" + vacancyIndex} className={vacancy.shisetsuKushitsuSu != "－" && vacancy.shisetsuKushitsuSu != "×" && vacancy.shisetsuKushitsuSu != "／"?
                    vacancy?.iroKbn == "gold" ? "crawlSearch_vacancyColGold"
                        : vacancy?.iroKbn == "red" ? "crawlSearch_vacancyColRed"
                            : vacancy?.iroKbn == "blue" ? "crawlSearch_vacancyColBlue"
                                : "crawlSearch_vacancyCol"
                    : "crawlSearch_vacancyColGray"}>
                    <Link
                        linkTitle={vacancy.shisetsuKushitsuSu == "×" || vacancy.shisetsuKushitsuSu == "－" || vacancy.shisetsuKushitsuSu == "／" ? "" : vacancy.shisetsuKushitsuSu}
                        className={
                            vacancy.shisetsuKushitsuSu == "×" ? "crawlSearch_cross" :
                                vacancy.shisetsuKushitsuSu == "－" ? "crawlSearch_minus" :
                                    vacancy.shisetsuKushitsuSu == "／" ? "crawlSearch_slash" :
                                        "crawlSearch_vacancyNumLink"
                        }
                        onClick={vacancy.shisetsuKushitsuSu != "×" && vacancy.shisetsuKushitsuSu != "－" && vacancy.shisetsuKushitsuSu != "／" ? () => { onClick(facility.facilityId, vacancy.riyoDate, false, "") } : null}
                    />
                </td>
            )}
        </tr>
    );

    return (
        <table className='crawlSearch_calendarTable'>
            <tbody>
                <tr>
                    <th className='crawlSearch_calendarHeader' colSpan={2}>
                        <Label label="ホテル名" />
                    </th>
                    {cols}
                </tr>
                {cols2}
            </tbody>
        </table>
    );
}